import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import Api from '../server/SystemTaskApi';
import { ActionTypes } from '../constants/CentricConstants';

export default {

    getTasks: (params) => {
        const types = {
            request:    ActionTypes.SYSTEM_TASK_LIST_REQUEST,
            success:    ActionTypes.SYSTEM_TASK_LIST_SUCCESS,
            failure:    ActionTypes.SYSTEM_TASK_LIST_FAILURE
        };

        return CentricDispatcher.dispatchAsync(Api.listTasks(params), types, {params});
    },

    getTask: (id) => {
        const types = {
            request:    ActionTypes.SYSTEM_TASK_INFO_REQUEST,
            success:    ActionTypes.SYSTEM_TASK_INFO_SUCCESS,
            failure:    ActionTypes.SYSTEM_TASK_INFO_FAILURE
        };

        return CentricDispatcher.dispatchAsync(Api.getTask(id), types, {id});
    },

    getJobs: (taskId, fromId) => {
        const types = {
            request:    ActionTypes.SYSTEM_TASK_JOB_LIST_REQUEST,
            success:    ActionTypes.SYSTEM_TASK_JOB_LIST_SUCCESS,
            failure:    ActionTypes.SYSTEM_TASK_JOB_LIST_FAILURE
        };

        return CentricDispatcher.dispatchAsync(Api.listJobs(taskId, fromId), types, {taskId, fromId});
    }
};
